// extracted by mini-css-extract-plugin
export default {"title":"DesignTitle_title__IarJA","fontSizeDesktop":"DesignTitle_fontSizeDesktop__r8bpT","fontSizeMobile":"DesignTitle_fontSizeMobile__gKLNQ"};